/**
 * Removes duplicate and empty string values from an array.
 *
 * @param {Array} array - Initial array with duplicate or empty values.
 * @returns {Array} New array with unique and non-empty values.
 */
export const extractUniqueAndNonEmptyArrayValues = (array) => {
  if (array == null || array.length === 0) {
    return [];
  }

  const arrayWithoutEmptyValues = array.filter((value) => value);
  const setWithUniqueValues = new Set(arrayWithoutEmptyValues);

  return Array.from(setWithUniqueValues);
};

/**
 * Splits arrays into smaller batches.
 * For instance, you can split 1000 items into batches of 500 by default.
 *
 * @returns {Array} New array with batches as items.
 */
export const splitArrayIntoBatches = (array, batchSize = 500) => {
  const batches = [];

  for (let i = 0; i < array.length; i += batchSize) {
    batches.push(array.slice(i, i + batchSize));
  }

  return batches;
};
